// Marketing type system: Instrument Serif for editorial display, Geist for UI/body,
// and Geist Mono for technical data.
import "@fontsource/instrument-serif";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import { PostHogProvider } from "@posthog/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { config } from "./config";
import { initPosthog, posthog } from "./posthogClient";
// Static, both of them. This is the quiz's own entry: the page a visitor lands on
// belongs in the entry bundle, and its CSS belongs in a <link> the browser can
// discover while parsing the HTML. Deferring either turns one parallel fetch into
// a sequential waterfall in front of first paint, on a page every ad click hits.
// The sales letter has its own entry (welcome.html) and never loads this bundle,
// which is what keeps the two stylesheets from colliding on :root/body/a.
import "./styles.css";

initPosthog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {config.posthogKey ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>,
);
